module.exports = __webpack_public_path__ + "img/icon_b.02e3e47b.png";